(function () {
    'use strict';

    angular.module("imApp").factory("p2SettingsService", ['$ihttp', function ($ihttp) {
        let service = {
            listP2Settings: function (parms) {
                return $ihttp.post({
                    method: 6,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
